'use client'

import { useState } from 'react'
import Link from 'next/link'
import { Menu, X } from 'lucide-react'
import { Button } from '@/components/ui/button'

const navItems = [
  { id: 'community', label: 'Community', href: '/#community' },
  { id: 'courses', label: 'Courses', href: '/courses' },
  { id: 'tools', label: 'Tools', href: '/#tools' },
  { id: 'ai-builder-pack', label: 'AI Builder Pack', href: '/#ai-builder-pack' },
  { id: 'pricing', label: 'Pricing', href: '/pricing' },
]

export default function CourseNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-black/50 backdrop-blur-md">
      <nav className="max-w-7xl mx-auto px-4 py-4">
        {/* Mobile */}
        <div className="flex justify-between items-center md:hidden">
          <button
            className="text-white p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <div className="flex space-x-2">
            <Link href="/auth/signin">
              <Button variant="ghost" className="text-white hover:text-white/80 text-sm px-3 py-1">
                Sign In
              </Button>
            </Link>
            <Link href="/auth/signin">
              <Button className="bg-white text-black hover:bg-white/90 text-sm px-3 py-1">
                Sign Up
              </Button>
            </Link>
          </div>

          {isMenuOpen && (
            <div className="absolute top-full left-0 right-0 bg-zinc-900 py-4">
              <ul className="flex flex-col space-y-2">
                {navItems.map((item) => (
                  <li key={item.id} className="px-4">
                    <Link
                      href={item.href}
                      className={`w-full text-left py-2 text-sm font-medium transition-colors block ${
                        item.id === 'courses'
                          ? 'text-white'
                          : 'text-white/60 hover:text-white/90'
                      }`}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* Desktop */}
        <div className="hidden md:flex items-center w-full relative">
          <div className="absolute left-1/2 transform -translate-x-1/2">
            <div className="bg-zinc-900/80 rounded-full px-4 py-1.5">
              <ul className="flex space-x-2">
                {navItems.map((item) => (
                  <li key={item.id}>
                    <Link
                      href={item.href}
                      className={`relative px-5 py-2.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                        item.id === 'courses'
                          ? 'text-white'
                          : 'text-white/60 hover:text-white/90'
                      }`}
                    >
                      {item.label}
                      {item.id === 'courses' && (
                        <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-10 h-0.5 bg-white"></span>
                      )}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="ml-auto flex space-x-3">
            <Link href="/auth/signin">
              <Button variant="ghost" className="text-white hover:text-white/80 text-sm px-4 py-2">
                Sign In
              </Button>
            </Link>
            <Link href="/auth/signin">
              <Button className="bg-white text-black hover:bg-white/90 text-sm px-4 py-2">
                Sign Up
              </Button>
            </Link>
          </div>
        </div>
      </nav>
    </div>
  )
}
